import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/rights',
    component: HeaderAsideLayout,
    children: [
      { path: '/rights', component: () => import('@/pages/rights/index.vue') },
    ],
  },
]
export default list